import { ApikeyAPIRepository } from "../../repositories"
import {IAPIKeyService} from "./apikey.types"

export class APIKeyService implements IAPIKeyService {
    constructor(readonly repository: ApikeyAPIRepository){}

    async getApikey(): Promise<any> {
        return await this.repository.getApikey()
    }
}